// extracted by mini-css-extract-plugin
export default {"header":"Header_header__VNKzZ","logo":"Header_logo__avGFU","button":"Header_button__isrJb"};